import React from "react";
import Section from "../Section";
import { pageTitle } from "../../helpers/PageTitle";

// Components for the new design pattern
import BannerSectionStyle3 from "../Section/BannerSection/BannerSectionStyle3";
import DepartmentSectionStyle2 from "../Section/DepartmentSection/DepartmentSectionStyle2";
import FeaturesSectionStyle2 from "../Section/FeaturesSection/FeaturesSectionStyle2";
import {
    BsPersonBadge,
    BsPrescription2,
    BsHeartPulse,
    BsShieldCheck,
    BsDatabaseLock,
    BsGlobeCentralSouthAsia
} from "react-icons/bs";

const doctorTestimonials = [
    {
        quote: "GKCKlinica simplifies the process by bringing services onto a single platform, making it easier for patients to submit and for doctors to review reports and provide timely prescriptions.",
        name: "Dr. Surbhi Bansal Agrawal",
        designation: "General Physician and Diabetologist",
        imgUrl: "/images/testimonials/surbhi-bansal.png"
    },
    {
        quote: "I see GKC Klinica as a bridge between experienced, verified orthopedic specialists and the many patients worldwide who are uncertain about whom to consult.",
        name: "Dr. Kiran Saoji",
        designation: "Orthopedic Specialist",
        imgUrl: "/images/testimonials/kiran-saoji.png"
    },
    {
        quote: "Platforms like GKC Klinica help patients identify and connect with verified eye care professionals on time, supporting better long-term eye health outcomes.",
        name: "Dr. Ajit Sinha",
        designation: "Eye Specialist",
        imgUrl: "/images/testimonials/ajit-sinha.png"
    },
    {
        quote: "Timely medical consultation plays a crucial role in preventing serious respiratory conditions. Digital platforms like GKC Klinica make it easier for patients to connect with verified specialists, ensuring early diagnosis, better disease management, and improved long-term health outcomes.",
        name: "Dr. Vivek Gupta",
        designation: "Pulmonologist | Specialist in Asthma and Lung care",
        imgUrl: "/images/testimonials/vivek-gupta.png"
    },
    {
        quote: "Good nutrition is the foundation of a healthy life. With platforms like GKC Klinica, patients can easily access expert dietary guidance, helping them adopt healthier habits, manage conditions effectively, and improve overall well-being.",
        name: "Vinita Mehta",
        designation: "Dietitian | MSc Food & Nutrition, PGDID, CDE",
        imgUrl: "/images/testimonials/vinita-mehta.png"
    },
    {
        quote: "Children’s health requires timely attention and the right guidance. Platforms like GKC Klinica help parents connect with trusted pediatric specialists quickly, ensuring early diagnosis, proper care, and healthier growth for their children.",
        name: "Dr. Sanjay Marathe",
        designation: "Child Specialist | Neonatologist",
        imgUrl: "/images/testimonials/sanjay-marathe.png"
    }
];



const whatWeDoData = [
    {
        title: "Verified Specialists",
        desc: "Direct access to licensed doctors and specialized healthcare professionals across various medical fields.",
        icon: <BsPersonBadge />
    },
    {
        title: "Diagnostic Centers",
        desc: "A structured digital path to book tests and access reliable medical reports from verified labs.",
        icon: <BsPrescription2 />
    },
    {
        title: "Wellness & Preventive",
        desc: "Proactive healthcare and wellness programs designed for long-term health and disease prevention.",
        icon: <BsHeartPulse />
    },
    {
        title: "Insurance Support",
        desc: "Integrated insurance services to make high-quality healthcare more affordable and accessible.",
        icon: <BsShieldCheck />
    },
    {
        title: "Blockchain Security",
        desc: "A token mechanism designed to enhance privacy and security while rewarding patient engagement.",
        icon: <BsDatabaseLock />
    },
    {
        title: "Global Medical Tourism",
        desc: "Bridging international borders by helping patients connect with trusted providers worldwide.",
        icon: <BsGlobeCentralSouthAsia />
    }
];

export default function About() {
    pageTitle("About GKC Klinica");

    return (
        <div className="about-page-wrapper" style={{ backgroundColor: "#cce7ef" }}>
            {/* HERO SECTION */}
            <BannerSectionStyle3
                bgUrl="/images/about/banner_bg.svg"
                imgUrl="/images/about/Revolutionizing.jpg"
                title="Healthcare Access — Reimagined for a Connected World"
                subTitle="GKC Klinica is building a technology-driven healthcare ecosystem designed to make quality healthcare services more accessible, transparent, and affordable for people everywhere."
            />

            {/* OUR VISION & MISSION - Alternating Layout */}
            <Section topMd={100} topLg={150}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="cs_section_heading cs_style_1">
                                <h3 className="cs_section_subtitle">OUR VISION</h3>
                                <h2 className="cs_section_title">Affordable Healthcare for Everyone</h2>
                                <p className="cs_section_text">
                                    GKC Klinica was founded with a simple but powerful vision — to make healthcare affordable and accessible for everyone.
                                    Our long-term goal is to build a privacy-first, hyper-integrated healthcare infrastructure that connects patients, doctors, and insurance within a single secure ecosystem.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <img src="/images/about/Vision.png" alt="Vision" className="img-fluid rounded-4 shadow" />
                        </div>
                    </div>
                </div>
            </Section>

            <Section topMd={100} topLg={150}>
                <div className="container">
                    <div className="row align-items-center flex-column-reverse flex-lg-row">
                        <div className="col-lg-6">
                            <img src="/images/about/Mission.png" alt="Mission" className="img-fluid rounded-4 shadow" />
                        </div>
                        <div className="col-lg-6">
                            <div className="cs_section_heading cs_style_1">
                                <h3 className="cs_section_subtitle">OUR MISSION</h3>
                                <h2 className="cs_section_title">Simplifying Healthcare Access</h2>
                                <p className="cs_section_text">
                                    Our mission is to simplify how people discover, access, and interact with healthcare services.
                                    We aim to connect patients worldwide with verified healthcare professionals through a secure, transparent, and technology-driven platform.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </Section>

            {/* WHAT IS GKC KLINICA - Two Column with Platform Image */}
            <Section topMd={100} topLg={150} className="cs_gray_bg py-5">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <h2 className="display-5 fw-bold mb-4">What is GKC Klinica?</h2>
                            <p className="lead">A technology company focused on improving access to healthcare services.</p>
                            <p>By bringing healthcare services together within one integrated digital ecosystem, GKC Klinica improves the overall patient experience while allowing partners to offer structured service packages and competitive pricing.</p>
                        </div>
                        <div className="col-lg-6 text-center">
                            <img src="/images/about/our.png" alt="Platform UI" className="img-fluid" />
                        </div>
                    </div>
                </div>
            </Section>

            {/* WHAT WE DO - Comprehensive Ecosystem Section */}
            <Section topMd={100} topLg={150} bottomMd={80}>
                <div className="container">
                    {/* Section Header */}
                    <div className="row justify-content-center text-center mb-5">
                        <div className="col-lg-8">
                            <h3 className="cs_section_subtitle">OUR ECOSYSTEM</h3>
                            <h2 className="cs_section_title mb-4">A One-Stop Digital Healthcare Ecosystem</h2>
                            <p className="text-muted fs-5">
                                GKC Klinica provides a unified platform connecting patients with licensed healthcare providers across multiple categories, simplifying the entire healthcare journey.
                            </p>
                        </div>
                    </div>

                    {/* Feature Grid */}
                    <div className="row g-4">
                        {whatWeDoData.map((item, index) => (
                            <div className="col-lg-4 col-md-6" key={index}>
                                <div className="cs_feature_box p-4 border rounded-4 h-100 hover-top shadow-sm bg-white transition-all">
                                    <div
                                        className="cs_feature_icon mb-3 bg-light rounded-3 d-inline-flex align-items-center justify-content-center"
                                        style={{ width: '60px', height: '60px', fontSize: '28px', color: '#3b82f6' }}
                                    >
                                        {/* 2. Render the Icon Component */}
                                        {item.icon}
                                    </div>
                                    <h4 className="fw-bold mb-3" style={{ fontSize: '1.25rem' }}>{item.title}</h4>
                                    <p className="text-muted small mb-0" style={{ lineHeight: '1.6' }}>
                                        {item.desc}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Bottom Context Info */}
                    <div className="mt-5 p-4 rounded-4 text-center border-dashed border-2" style={{ border: '2px dashed #e2e8f0' }}>
                        <p className="mb-0 text-muted italic">
                            All services are delivered through a structured digital ecosystem designed to <strong>simplify the healthcare journey</strong> for both patients and healthcare professionals.
                        </p>
                    </div>
                </div>
            </Section>

            {/* FOUNDER'S MESSAGE - Narrative Style */}
            {/* <Section topMd={100} topLg={150} bottomMd={100} className="cs_light_bg">
                <div className="container">
                    <div className="row align-items-center">
           
                        <div className="col-lg-5 mb-5 mb-lg-0">
                            <div className="cs_founder_img_wrapper position-relative">
                                <img
                                    src="/images/about/lalit.png"
                                    alt="Lalit Rai - Founder"
                                    className="img-fluid rounded-5 shadow-lg"
                                    style={{ width: '100%', objectFit: 'cover', minHeight: '500px' }}
                                />
                                <div className="cs_founder_label position-absolute bottom-0 start-0 m-4 p-4 bg-white rounded-4 shadow">
                                    <h4 className="mb-0 fw-bold">Lalit Rai</h4>
                                    <p className="text-primary mb-0 small fw-bold">Founder, GKC Klinica</p>
                                </div>
                            </div>
                        </div>

                   
                        <div className="col-lg-7 ps-lg-5">
                            <div className="cs_section_heading cs_style_1 mb-4">
                                <h3 className="cs_section_subtitle">FOUNDER'S MESSAGE</h3>
                                <h2 className="cs_section_title mb-3">A Personal Mission for Global Care</h2>
                            </div>

                            <div className="cs_founder_text text-muted" style={{ lineHeight: '1.8', fontSize: '1.05rem' }}>
                                <p className="fw-medium text-dark mb-4">
                                    "Digital technology has transformed the world into a global village. Our goal is to harness the power of digitization to make quality healthcare accessible to everyone, regardless of geography."
                                </p>

                                <p>
                                    At GKC Klinica, our journey began with a simple belief — quality healthcare should be accessible, transparent, and affordable for everyone. During one of my travels, I had a conversation with a co-passenger from Michigan who described her difficulty in finding the right doctor for joint replacement surgery in India.
                                </p>

                                <div className="cs_highlight_box my-4 p-4 bg-white border-start border-primary border-4 rounded-2">
                                    That conversation highlighted a larger gap — patients needed a trusted platform where they could connect directly with verified doctors and securely share their medical information.
                                </div>

                                <p>
                                    This insight led to the founding of <strong>GKC Klinica</strong>. We are building a technology-driven ecosystem that connects patients with verified doctors, diagnostic centers, and wellness providers through a single integrated platform.
                                </p>

                                <p className="mb-0">
                                    GKC Klinica is more than a technology platform — it is a step toward a more connected and inclusive healthcare ecosystem. Together, we remain committed to creating meaningful value for patients worldwide.
                                </p>
                            </div>

                            <div className="mt-5">
                                <img src="/images/about/lalit-sign.png" alt="Signature" style={{ maxHeight: '60px', opacity: '0.8' }} />
                            </div>
                        </div>
                    </div>
                </div>
            </Section> */}
            <Section
                topMd={100}
                topLg={140}
                bottomMd={100}
                className="cs_light_bg"
                style={{
                    background: "linear-gradient(135deg, #f5f9ff 0%, #eef4ff 100%)"
                }}
            >
                <div className="container">
                    <div className="row align-items-center">

                        {/* 🔹 Founder Image */}
                        <div className="col-lg-5 mb-5 mb-lg-0">
                            <div className="position-relative" style={{ marginTop: "-60px" }}>

                                <div style={{ position: "relative", width: "100%", maxWidth: "500px", margin: "0 auto" }}>

                                    {/* Image Card */}
                                    <div
                                        style={{
                                            padding: "12px",
                                            background: "#ffffff",
                                            borderRadius: "20px",
                                            boxShadow: "0 15px 40px rgba(0,0,0,0.12)",
                                            position: "relative",
                                            zIndex: 2
                                        }}
                                    >
                                        <img
                                            src="/images/about/lalit.png"
                                            alt="Lalit Rai - Founder"
                                            style={{
                                                width: "100%",
                                                height: "auto",           // ✅ Responsive height
                                                maxHeight: "560px",       // ✅ Limit for large screens
                                                objectFit: "cover",
                                                borderRadius: "16px"
                                            }}
                                        />
                                    </div>

                                    {/* Background Shape */}
                                    <div
                                        style={{
                                            position: "absolute",
                                            top: "20px",
                                            left: "-10px",
                                            width: "100%",
                                            height: "100%",
                                            background: "linear-gradient(135deg, #0ea5e9, #2563eb)",
                                            borderRadius: "20px",
                                            zIndex: 1,
                                            opacity: 0.15
                                        }}
                                    />
                                </div>

                                {/* Label */}
                                {/* <div
                                    className="position-absolute"
                                    style={{
                                        bottom: "20px",
                                        left: "20px",
                                        background: "#fff",
                                        padding: "16px 22px",
                                        borderRadius: "14px",
                                        boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                                        zIndex: 2
                                    }}
                                >
                                    <h5 className="mb-1 fw-bold">Lalit Rai</h5>
                                    <p className="mb-0 text-primary small fw-semibold">
                                        Founder, GKC Klinica
                                    </p>
                                </div> */}
                            </div>
                        </div>

                        {/* 🔹 Founder Content */}
                        <div className="col-lg-7 ps-lg-5">
                            <div className="mb-4">

                                <h2
                                    className="fw-bold mb-1"
                                    style={{
                                        fontSize: "3rem",
                                        lineHeight: "1.1",
                                        color: "#000",
                                        letterSpacing: "-1px",
                                    }}
                                >
                                    Lalit Rai
                                </h2>

                                <div
                                    style={{
                                        display: "inline-block",
                                        padding: "6px 14px",
                                        borderRadius: "30px",
                                        background: "rgba(14,165,233,0.12)",
                                        color: "#0ea5e9",
                                        fontSize: "0.9rem",
                                        fontWeight: "700",
                                        letterSpacing: "1px",
                                        textTransform: "uppercase",
                                        marginBottom: "18px",
                                    }}
                                >
                                    Founder, GKC Klinica
                                </div>

                                <h6
                                    className="fw-bold mb-2"
                                    style={{
                                        color: "#0ea5e9",
                                        letterSpacing: "1px",
                                    }}
                                >
                                    FOUNDER'S MESSAGE
                                </h6>

                                <h2
                                    className="fw-bold mb-3"
                                    style={{
                                        fontSize: "2.2rem",
                                        lineHeight: "1.3",
                                        color: "#1e293b",
                                    }}
                                >
                                    A Vision to Transform Healthcare Access
                                </h2>

                            </div>
                            <div
                                className="text-muted"
                                style={{ lineHeight: "1.9", fontSize: "1.05rem" }}
                            >
                                <p className="fw-semibold text-dark mb-4">
                                    "Digital technology has transformed the world into a global village.
                                    Our goal is to leverage this power to make quality healthcare
                                    accessible to everyone."
                                </p>

                                <p>
                                    At GKC Klinica, our journey started with a simple yet powerful belief —
                                    healthcare should be accessible, transparent, and affordable. During
                                    one of my travels, I encountered a patient struggling to find the right
                                    specialist in India.
                                </p>

                                {/* Highlight Box */}
                                <div
                                    style={{
                                        background: "#ffffff",
                                        padding: "20px",
                                        borderLeft: "4px solid #2563eb",
                                        borderRadius: "10px",
                                        boxShadow: "0 10px 25px rgba(0,0,0,0.05)",
                                        margin: "25px 0",
                                        fontWeight: 500
                                    }}
                                >
                                    This moment revealed a major gap — patients need a trusted platform
                                    to connect with verified doctors and securely manage their medical data.
                                </div>

                                <p>
                                    This insight led to the creation of <strong>GKC Klinica</strong>, a
                                    digital ecosystem connecting patients with verified healthcare
                                    providers, diagnostic centers, and wellness services — all in one place.
                                </p>

                                <p className="mb-0">
                                    We are committed to building a more connected, reliable, and inclusive
                                    healthcare system that delivers real value to patients worldwide.
                                </p>
                            </div>

                            {/* Signature */}
                            {/* <div className="mt-4">
                                <img
                                    src="/images/about/lalit-sign.png"
                                    alt="Signature"
                                    style={{ maxHeight: "60px", opacity: 0.85 }}
                                />
                            </div> */}
                        </div>

                    </div>
                </div>
            </Section>

            {/* DOCTOR TESTIMONIALS - Grid Pattern */}
            <Section topMd={100} topLg={150}>
                <div className="container">
                    <div className="text-center mb-5">
                        <h3 className="cs_section_subtitle">TESTIMONIALS</h3>
                        <h2 className="cs_section_title">Trusted by Leading Medical Professionals</h2>
                    </div>
                    <div className="row">
                        <div className="row">
                            {doctorTestimonials.map((item, index) => (
                                <div className="col-lg-4 col-md-6 mb-4" key={index}>

                                    <div className="cs_testimonial_card p-4 shadow-sm border rounded-4 h-100 d-flex flex-column justify-content-between">

                                        <div className="cs_testimonial_top">

                                            <p className="cs_testimonial_quote mb-4 text-muted" style={{ fontStyle: 'italic', lineHeight: '1.6' }}>
                                                "{item.quote}"
                                            </p>
                                        </div>

                                        <div className="cs_testimonial_footer d-flex align-items-center mt-auto pt-3 border-top">

                                            <div className="cs_testimonial_avatar flex-shrink-0">
                                                <img
                                                    src={item.imgUrl || '/images/default-doctor.png'}
                                                    alt={item.name}
                                                    className="rounded-circle"
                                                    style={{ width: '60px', height: '60px', objectFit: 'cover', border: '2px solid #f0f0f0' }}
                                                />
                                            </div>

                                            <div className="ms-3">
                                                <h5 className="mb-1 fw-bold" style={{ fontSize: '1.1rem', color: '#333' }}>
                                                    {item.name}
                                                </h5>

                                                <span
                                                    className="text-primary d-block lh-sm"
                                                    style={{ fontSize: '0.85rem', fontWeight: '500', maxWidth: '200px' }}
                                                >
                                                    {item.designation}
                                                </span>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </Section>

            {/* FINAL CTA SECTION */}
            <Section topMd={100} topLg={150} bottomMd={100} className="text-center pb-5">
                <div className="container p-5 bg-light rounded-5 shadow-sm">
                    <h2 className="display-6 fw-bold">Building the Future of Healthcare Access</h2>
                    <p className="mx-auto col-lg-8 mt-3 mb-4 text-muted">
                        GKC Klinica is working toward a future where healthcare services are easier to access, easier to trust, and better connected across the world.
                    </p>
                    <button className="btn btn-primary btn-lg px-5" onClick={() => window.location.href = "https://app.gkcklinica.com/login"}>Join the Journey</button>
                </div>
            </Section>
        </div>
    );
}